module.exports = __webpack_public_path__ + "static/assets/87d74d4cc01b725708781f40a8b0c7b5.svg";